// import Paper from "@mui/material/Paper";
// import Table from "@mui/material/Table";
// import TableBody from "@mui/material/TableBody";
// import TableCell from "@mui/material/TableCell";
// import TableContainer from "@mui/material/TableContainer";
// import TableHead from "@mui/material/TableHead";
// import TableRow from "@mui/material/TableRow";
// import Skeleton from '@mui/material/Skeleton';
// import React, { useMemo, useState, useEffect, useRef } from "react";
// import { useSelector } from "react-redux";
// import { dateDiff, dateFormat, convertToPercent, formatCurrencyRound, truncate, deepCopy } from "../../app/util";
// import { toast } from 'react-toastify';
// import DataService from "../../services/data.service";
// import { Box, CircularProgress, Tooltip, IconButton, Chip, Alert, AlertTitle } from '@mui/material/';
// import "./productRestriction/style.css";
// import { RowDataContext, RatePlanRowDataContext, RowDataProvider, BucketDataProvider, RowStateProvider, RowStateContext } from './productRestriction/contexts';
// import { ThresholdDisplay, BadgeCountDisplay, ColumnSorting } from './productRestriction/helper-components';
// import Filter from "./Filter";
// import icons from './productRestriction/svgIcons';
// import NotesPopup from './NotesPopup';
// import EventsPopup from './EventsPopup';
// import moment from "moment";
// import originalData from "./productRestriction/logs-data-moel.json"
// import { groupRoomTypes } from "../../app/productService";
// import { useFetchApi } from '../../hooks/useFetchApi';
// import { renderDefaultRestrictions } from "./productRestriction/components/BucketDetailsTable";


// const stickyStyle1 = {
//     position: 'sticky',
//     top: 0,
//     zIndex: 3,
// };

// const stickyStyle2 = {
//     position: 'sticky',
//     top: 30,
//     zIndex: 3,
// };

// const cellStyle = {
//     //border: '0.5px solid #ccc',
//     padding: '8px 8px',
//     textAlign: 'center',
//     textWrap: "nowrap"
// };

// const cellStyleHeader = {
//     border: '0.5px solid #EBEBEB',
//     padding: '4px 8px',
//     textAlign: 'center',
//     textWrap: "nowrap"
// };


// function TableProductRestrictionReports() {
//     let initialTableData = [];
//     const { auth } = useSelector(appState => appState);
//     const { app_state, ui_state } = useSelector((state) => state.app.current_state);
//     if (app_state.workspace_controls.logsRatePushMode === "date") {
//         initialTableData = DataService.getSeriesById("RestrictionsProductStatus")?.data?.data;
//         //initialTableData = [originalData[0]];

//     } else {
//         initialTableData = DataService.getSeriesById("RestrictionsProductStatusDateRange")?.data?.data;
//         //initialTableData = [...originalData];
//     }
//     if (!initialTableData) {
//         initialTableData = [];
//     }

//     const { room_settings } = app_state;
//     const { property_details } = useSelector(state => state.auth.profile);
//     const { currency_symbol } = ui_state;
//     const visibleDOWTitle = ui_state.table_filters.table_common.dow.map(item => item.title);
//     const {
//         uploadIcon,
//         rightArrowIcon,
//         greenUploadIcon,
//         deleteRowIcon,
//         panelToggleIcon
//     } = icons;


//     const [expandedRows, setExpandedRows] = useState(null);
//     const cellRef = useRef(null);
//     const [containerWidth, setContainerWidth] = useState("100%");
//     const [cols, setCols] = useState([
//         { type: "date", filterable: false, sorted: null },
//         { type: "dow", filterable: true, sorted: null },
//     ])
//     // const [data, setData] = useState(initialTableData || []);
//     const [data, setData] = useState([]);


//     // const {
//     //     isLoading: isSecondLoading,
//     //     isSuccess: isSecondSuccess,
//     //     data: secondData,
//     //     error: secondError,
//     //     refetch: callApi
//     // } = useFetchApi('getDateRestrictionsLogs', {}, 'GET', true);

//     // useEffect(() => {
//     //     if (isSecondSuccess && secondData?.data) {
//     //         setData(secondData.data);
//     //     }
//     // }, [isSecondSuccess]);

//     useEffect(() => {
//         if (cellRef.current) {
//             setContainerWidth(cellRef.current.offsetWidth - 10 + "px");
//         }

//         // Update width on window resize
//         const handleResize = () => {
//             if (cellRef.current) {
//                 setContainerWidth(cellRef.current.offsetWidth - 10 + "px");
//             }
//         };

//         window.addEventListener("resize", handleResize);

//         return () => window.removeEventListener("resize", handleResize);
//     }, []);

//     useEffect(() => {

//         setExpandedRows(null);
//         // const filteredData = initialTableData?.filter(item => visibleDOWTitle.includes(item.dow));
//         console.log(initialTableData);

//         const filteredData = Array.isArray(initialTableData)
//             ? initialTableData.filter(item => visibleDOWTitle.includes(item.dow))
//             : [];

//         let item = cols.find(col => col.sorted !== null);

//         // sorting
//         let sortedData = [];
//         if (item && item.sorted === 'asc' || item === undefined) {
//             sortedData = filteredData.sort((a, b) => {
//                 if (item === undefined) {
//                     item = cols[0];
//                 }

//                 if (item.type === "date") {
//                     return new Date(a[item.type]) - new Date(b[item.type]);
//                 } else {
//                     return a[item.type].localeCompare(b[item.type]);
//                 }
//             });
//         }
//         if (item && item.sorted === 'desc') {
//             sortedData = filteredData.sort((a, b) => {
//                 if (item.type === "date") {
//                     return new Date(b[item.type]) - new Date(a[item.type]);
//                 } else {
//                     return b[item.type].localeCompare(a[item.type]);
//                 }
//             });
//         }
//         setData([...sortedData]);

//     }, [visibleDOWTitle.toString(), cols[0].sorted, cols[1].sorted]);


//     const onClickHandler = (date) => {
//         setExpandedRows((prev) => (prev === date ? null : date));
//     };



//     const onOrderByChangeHandler = (item) => {
//         const forUpdate = deepCopy(cols)

//         forUpdate.map((col) => {
//             col.sorted = null;
//             if (col.type === item.type) {
//                 col.sorted = item.sorted;
//             }
//             return col;
//         })
//         console.log('cols', forUpdate);
//         setCols(forUpdate);

//     }

//     if (!Array.isArray(initialTableData)) {
//         return (<Box sx={{ p: 1 }}>
//             <Alert severity="info">
//                 <AlertTitle>Info</AlertTitle>
//                 Logs for product restrictions are not found!.
//             </Alert>
//         </Box>)
//     } else {
//         return (
//             <TableContainer component={Paper} className="product-restrictions-container" ref={cellRef}>
//                 <Table stickyHeader className="table-product-restrictions reports" >
//                     <TableHead className="table-headers" >
//                         {/* Primary Header */}
//                         <TableRow className='primary-header' >
//                             <TableCell colSpan={2} style={{ ...cellStyleHeader, ...stickyStyle1, left: "0px", zIndex: 5 }}> 2025 </TableCell>
//                             <TableCell style={{ ...cellStyleHeader, ...stickyStyle1, left: "200px", zIndex: 5 }}> </TableCell>
//                             <TableCell colSpan={5} style={{ ...cellStyleHeader, ...stickyStyle1 }}> Tracking </TableCell>
//                         </TableRow>

//                         {/* Secondary Header */}
//                         <TableRow className='secondary-header' >
//                             <TableCell className='col-date' rowSpan={2} style={{ ...cellStyleHeader, ...stickyStyle2, left: "0px", zIndex: 5 }}>
//                                 <Box className="date-cell" >
//                                     <ColumnSorting
//                                         label="Date"
//                                         colItem={cols[0]}
//                                         sorted={cols[0].sorted}
//                                         onOrderByChange={onOrderByChangeHandler} />
//                                     <Box sx={{ ml: 1 }}> Date </Box>
//                                 </Box>
//                             </TableCell>
//                             <TableCell className='col-dow' rowSpan={2} style={{ ...cellStyleHeader, ...stickyStyle2, left: "100px", zIndex: 5 }}>
//                                 <Box className="dow-cell" >
//                                     <ColumnSorting
//                                         label="DOW"
//                                         colItem={cols[1]}
//                                         sorted={cols[1].sorted}
//                                         onOrderByChange={onOrderByChangeHandler} />
//                                     <Box> Dow </Box>
//                                     <Box className="filter-container">
//                                         {visibleDOWTitle.length < 7 && <span className={'has-filter'}></span>}
//                                         <Filter
//                                             currentColumn={cols[1]}
//                                             columnList={[]}
//                                             applyFilterHandler={() => { }}
//                                         />
//                                     </Box>
//                                 </Box>
//                             </TableCell>
//                             <TableCell className='col-threshold' style={{ ...cellStyleHeader, ...stickyStyle2, left: "200px", zIndex: 5 }}> Threshold({currency_symbol})</TableCell>
//                             <TableCell className='col-updated-time' style={{ ...cellStyleHeader, ...stickyStyle2 }}> Updated Time </TableCell>
//                             <TableCell className='col-action' style={{ ...cellStyleHeader, ...stickyStyle2 }}> Action </TableCell>
//                             <TableCell className='col-status' style={{ ...cellStyleHeader, ...stickyStyle2 }}> Status </TableCell>
//                             <TableCell className='col-user' style={{ ...cellStyleHeader, ...stickyStyle2 }}> User </TableCell>
//                         </TableRow>
//                     </TableHead>


//                     <TableBody className='table-body'>
//                         <RowStateProvider value={{ prevActiveRow: null, activeRow: null }} >
//                             {data.map((dateRow, index) => {
//                                 const {
//                                     date,
//                                     dow,
//                                     badge_count,
//                                     threshold_prev,
//                                     threshold_curr,
//                                     updated_time,
//                                     action,
//                                     status,
//                                     user,
//                                     buckets
//                                 } = dateRow;
//                                 const dayAndMonth = moment(date).format("MMM DD");
//                                 const updatedTime = moment(updated_time).format("ddd, MMM DD, YYYY, hh:mm A");

//                                 // const roomListArray = buckets.map((bucket) => {
//                                 //     return bucket.rate_plans.map((plan) =>{
//                                 //         return plan.rooms_summary.map((room) =>{
//                                 //             return room.room_type_code;
//                                 //         });
//                                 //     });
//                                 // })
//                                 // const uniqueRoomList = getUnique(roomListArray.flat(2));

//                                 const uniqueRoomList = groupRoomTypes(room_settings);

//                                 return (
//                                     <>
//                                         {/* level 1 data rows */}
//                                         <TableRow className={`level-one-row ${index % 2 === 0 ? 'even' : 'odd'}`}>
//                                             <TableCell className='col-date' style={cellStyle}>
//                                                 <Box className="date-cell">
//                                                     <NotesPopup params={{ stay_date: date }} />
//                                                     <Box sx={{ position: "relative" }} onClick={() => onClickHandler(date)}>
//                                                         <div className='badge-count'>{badge_count}</div>
//                                                         {dayAndMonth}
//                                                     </Box>
//                                                     <IconButton
//                                                         className={`toggle-icon ${expandedRows === date ? 'arrow-up' : 'arrow-down'}`}
//                                                         size='small'
//                                                         onClick={() => onClickHandler(date)}
//                                                         sx={{ p: 0 }}>
//                                                         {expandedRows === date ? icons.arrowUpIcon : icons.arrowDownIcon}
//                                                     </IconButton>
//                                                 </Box>
//                                             </TableCell>
//                                             <TableCell className='col-dow' style={cellStyle}>
//                                                 <Box className="dow-cell">
//                                                     <EventsPopup params={{ stay_date: date }} />
//                                                     <Box>{dow}</Box>
//                                                 </Box>
//                                             </TableCell>
//                                             <TableCell className='col-threshold' style={cellStyle}>
//                                                 <Box className='threshold-cell'>
//                                                     <div>{threshold_prev}</div>
//                                                     {rightArrowIcon}
//                                                     <div>{threshold_curr}</div>
//                                                 </Box>
//                                             </TableCell>
//                                             <TableCell className='col-updated-time' style={cellStyle}> {updatedTime}</TableCell>
//                                             <TableCell className='col-action' style={cellStyle}> {action} </TableCell>
//                                             <TableCell className='col-status' style={cellStyle}> {status} </TableCell>
//                                             <TableCell className='col-user' style={cellStyle}> {user} </TableCell>
//                                         </TableRow>


//                                         {expandedRows === date && (
//                                             <>
//                                                 <TableRow className="expanded-row">
//                                                     <TableCell colSpan={7} className="col-level-two-container">
//                                                         <Box className="level-two-container" style={{ overflowX: "auto", width: containerWidth }}>
//                                                             <StatusDetail
//                                                                 uniqueRoomList={uniqueRoomList}
//                                                                 date={date}
//                                                                 buckets={buckets}
//                                                                 containerWidth={containerWidth}
//                                                                 currency_symbol={currency_symbol}
//                                                             />
//                                                         </Box>
//                                                     </TableCell>
//                                                 </TableRow>
//                                             </>
//                                         )}
//                                     </>
//                                 );
//                             })}
//                         </RowStateProvider>
//                     </TableBody>
//                 </Table>
//             </TableContainer>
//         )
//     }
// }

// export default TableProductRestrictionReports;


// function StatusDetail({ uniqueRoomList, date, containerWidth, buckets, currency_symbol }) {

//     // const { 
//     //         isLoading,
//     //         isSuccess,
//     //         data,
//     //         error,
//     //         refetch, 
//     //     } = useFetchApi('getDateRestrictionStatusDetails', { uiHelper: true, stayDate: date }, 'GET', true, date);

//     if (!buckets?.length) {
//         return (
//             <LevelOneLoader
//                 selectedRoomTypes={uniqueRoomList}
//                 cellStyleHeader={cellStyleHeader}
//                 cellStyle={cellStyle}
//             />
//         );
//     }

//     return (
//         <>
//             <Box className="level-two-container" style={{ overflowX: "auto", width: containerWidth }}>
//                 <Table stickyHeader>
//                     <TableBody className="table-body">

//                         {/* level 2 top header */}
//                         <TableRow className="level-two-header">
//                             <TableCell className="sell-rate-bucket">Sell Rate Bucket</TableCell>
//                             {uniqueRoomList.map((roomType) => (
//                                 <TableCell colSpan={2}>{roomType}</TableCell>
//                             ))}
//                         </TableRow>


//                         {buckets.map((bucket, index) => (
//                             <>
//                                 {/* level 2 bottom header */}
//                                 {index === 0 ? (
//                                     <TableRow className="level-two-header bottom-header">
//                                         <TableCell className="sell-rate-bucket">{bucket.label}</TableCell>
//                                         {uniqueRoomList.map((roomType) => (
//                                             <>
//                                                 <TableCell className="col-sell-rate">Sell Rate ({currency_symbol})</TableCell>
//                                                 <TableCell className="col-restriction">Restrictions</TableCell>
//                                             </>
//                                         ))}
//                                     </TableRow>
//                                 )
//                                     :
//                                     (
//                                         <TableRow className="level-two-header bottom-header">
//                                             <TableCell colSpan={1} className="sell-rate-bucket" style={{ borderRight: "unset" }}>{bucket.label}</TableCell>
//                                             <TableCell colSpan={uniqueRoomList.length * 2}></TableCell>
//                                         </TableRow>
//                                     )
//                                 }


//                                 {/* level 2 data rows */}
//                                 {bucket.rate_plans.map((plan) => (
//                                     <TableRow className="level-two-row">
//                                         <TableCell className="sell-rate-bucket">
//                                             <Tooltip arrow title={plan?.label} followCursor>
//                                                 {plan.rate_plan_code}
//                                             </Tooltip> {renderDefaultRestrictions(plan?.default_restrictions)}
//                                         </TableCell>
//                                         {uniqueRoomList.map((roomType) => {
//                                             const roomData = plan.rooms_summary.find(room => room.room_type_code === roomType);
//                                             return (
//                                                 <>
//                                                     <TableCell className="col-sell-rate">{roomData?.sell_rate ?? "-"}</TableCell>
//                                                     <TableCell className='col-restrictions'>
//                                                         <Box className='restrictions-container'>
//                                                             {roomData?.restrictions?.pre.map((restriction) => {
//                                                                 let chipClass = `chip-${restriction.toLowerCase()} removed `;
//                                                                 return (
//                                                                     <Chip className={`restrictions-chips ${chipClass}`} label={restriction} variant="outlined" />
//                                                                 )
//                                                             })}
//                                                             {roomData?.restrictions?.curr.map((restriction) => {
//                                                                 let chipClass = `chip-${restriction.toLowerCase()}`;
//                                                                 return (
//                                                                     <Chip className={`restrictions-chips ${chipClass}`} label={restriction} variant="outlined" />
//                                                                 )
//                                                             })}
//                                                         </Box>
//                                                     </TableCell>
//                                                 </>
//                                             )
//                                         })}
//                                     </TableRow>
//                                 ))}
//                             </>
//                         ))}
//                     </TableBody>
//                 </Table>
//             </Box>
//         </>
//     );
// }

// const LevelOneLoader = ({ selectedRoomTypes, }) => {
//     const rowCount = Array.from({ length: 3 });

//     return (
//         <Table style={{ width: "100%" }}>
//             <TableRow className='level-two-header'>
//                 <TableCell className='sell-rate-bucket' style={{ width: 350 }}>
//                     <Skeleton variant="rounded" height={18} width={314} />
//                 </TableCell>
//                 {selectedRoomTypes.map((roomType, index) => (
//                     <React.Fragment key={index}>
//                         <TableCell colSpan={2}>
//                             <Skeleton variant="rounded" height={18} />
//                         </TableCell>
//                     </React.Fragment>
//                 ))}
//             </TableRow>
//             {rowCount.map((_, rowIndex) => (
//                 <TableRow key={rowIndex} className='level-two-row'>
//                     <TableCell className='col-rate-bucket' style={{ width: 350 }}>
//                         <Skeleton variant="rounded" height={18} width={314} />
//                     </TableCell>
//                     {selectedRoomTypes.map((roomType, index) => {
//                         return (
//                             <React.Fragment key={index}>
//                                 <TableCell className='col-sell-rate' >
//                                     <Skeleton variant="rounded" height={18} />
//                                 </TableCell>
//                                 <TableCell className='col-cur-restrictions' >
//                                     <Skeleton variant="rounded" height={18} />
//                                 </TableCell>
//                             </React.Fragment>
//                         );
//                     })}
//                 </TableRow>
//             ))}
//         </Table>
//     );
// };


import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Skeleton from "@mui/material/Skeleton";
import React, { useState, useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import { deepCopy } from "../../app/util";
import { Box, Tooltip, IconButton, Chip, Alert, AlertTitle } from "@mui/material/";
import "./productRestriction/style.css";
import {
    RowStateProvider,
} from "./productRestriction/contexts";
import { ColumnSorting } from "./productRestriction/helper-components";
import Filter from "./Filter";
import icons from "./productRestriction/svgIcons";
import NotesPopup from "./NotesPopup";
import EventsPopup from "./EventsPopup";
import moment from "moment";
import DataService from "../../services/data.service";
import { groupRoomTypes } from "../../app/productService";
import { renderDefaultRestrictions } from "./productRestriction/components/BucketDetailsTable";

const stickyStyle1 = {
    position: "sticky",
    top: 0,
    zIndex: 4,
};

const stickyStyle2 = {
    position: "sticky",
    top: 29,
    zIndex: 4,
};

const cellStyle = {
    padding: "8px 8px",
    textAlign: "center",
    textWrap: "nowrap",
};

const cellStyleHeader = {
    border: "0.5px solid #EBEBEB",
    padding: "4px 8px",
    textAlign: "center",
    textWrap: "nowrap",
};

function TableProductRestrictionReports() {
    const { app_state, ui_state } = useSelector((state) => state.app.current_state);
    const { room_settings } = app_state;
    const { currency_symbol } = ui_state;
    const visibleDOWTitle = ui_state.table_filters.table_common.dow.map((item) => item.title);

    let initialTableData = [];
    if (app_state.workspace_controls.logsRatePushMode === "date") {
        initialTableData = DataService.getSeriesById("RestrictionsProductStatus")?.data?.data;
    } else {
        initialTableData = DataService.getSeriesById("RestrictionsProductStatusDateRange")?.data?.data;
    }
    if (!initialTableData) initialTableData = [];

    const { rightArrowIcon } = icons;

    const [expandedRows, setExpandedRows] = useState(null);
    const [containerWidth, setContainerWidth] = useState("100%");
    const [cols, setCols] = useState([
        { type: "date", filterable: false, sorted: null },
        { type: "dow", filterable: true, sorted: null },
    ]);
    const [data, setData] = useState([]);
    const mainScrollRef = useRef(null);

    useEffect(() => {
        if (mainScrollRef.current) {
            setContainerWidth(mainScrollRef.current.offsetWidth - 10 + "px");
        }
        const handleResize = () => {
            if (mainScrollRef.current) {
                setContainerWidth(mainScrollRef.current.offsetWidth - 10 + "px");
            }
        };
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    useEffect(() => {
        setExpandedRows(null);
        const filteredData = Array.isArray(initialTableData)
            ? initialTableData.filter((item) => visibleDOWTitle.includes(item.dow))
            : [];

        let item = cols.find((col) => col.sorted !== null);
        let sortedData = [];

        if ((item && item.sorted === "asc") || item === undefined) {
            sortedData = filteredData.sort((a, b) => {
                if (item === undefined) item = cols[0];
                if (item.type === "date") return new Date(a[item.type]) - new Date(b[item.type]);
                return a[item.type].localeCompare(b[item.type]);
            });
        }
        if (item && item.sorted === "desc") {
            sortedData = filteredData.sort((a, b) => {
                if (item.type === "date") return new Date(b[item.type]) - new Date(a[item.type]);
                return b[item.type].localeCompare(a[item.type]);
            });
        }

        let uniqueByDate = [];
        if (app_state?.workspace_controls?.logsRatePushMode === 'date_range') {
            const sorted = sortedData.sort((a, b) => moment(b.updated_time).diff(moment(a.updated_time)));

            // 2️ Remove duplicates by date (keep the latest)
            // const uniqueByDate = [];
            const seenDates = new Set();

            for (const item of sorted) {
                if (!seenDates.has(item.date)) {
                    seenDates.add(item.date);
                    uniqueByDate.push(item);
                }
            }
        } else {
            uniqueByDate = sortedData.sort((a, b) => moment(b.updated_time).diff(moment(a.updated_time)));
        }
        setData([...uniqueByDate]);
        // setData([...sortedData]);
    }, [visibleDOWTitle.toString(), cols[0].sorted, cols[1].sorted]);

    const onClickHandler = (rowId) => {
        setExpandedRows(prev => (prev === rowId ? null : rowId));
    };

    const onOrderByChangeHandler = (item) => {
        const forUpdate = deepCopy(cols);
        forUpdate.map((col) => {
            col.sorted = null;
            if (col.type === item.type) col.sorted = item.sorted;
            return col;
        });
        setCols(forUpdate);
    };

    /** 
     * Unified vertical scroll sync logic
     * -------------------------------------------------
     * When scrolling inside the table:
     * - If an expanded inner table has vertical overflow, it consumes the scroll first.
     * - Once its top or bottom is reached, the main container scrolls.
     * - Each inner table keeps its own horizontal scroll independent.
     */
    // useEffect(() => {
    //     const main = mainScrollRef.current;
    //     if (!main) return;

    //     const handleWheel = (e) => {
    //         let deltaY = e.deltaY;
    //         let consumed = false;

    //         const inners = document.querySelectorAll(".level-two-container-scrollable");
    //         inners.forEach((inner) => {
    //             const maxScroll = inner.scrollHeight - inner.clientHeight;
    //             const atTop = inner.scrollTop === 0;
    //             const atBottom = inner.scrollTop >= maxScroll;

    //             if ((deltaY < 0 && !atTop) || (deltaY > 0 && !atBottom)) {
    //                 inner.scrollTop += deltaY;
    //                 consumed = true;
    //             }
    //         });

    //         if (consumed) e.preventDefault();
    //     };

    //     main.addEventListener("wheel", handleWheel, { passive: false });
    //     return () => main.removeEventListener("wheel", handleWheel);
    // }, []);

    useEffect(() => {
        const main = mainScrollRef.current;
        if (!main) return;

        let touchStartY = 0;

        const getScrollableInner = (target) =>
            target.closest(".level-two-container-scrollable");

        const handleScrollAttempt = (deltaY, target) => {
            const inner = getScrollableInner(target);
            if (!inner) return false;

            const maxScroll = inner.scrollHeight - inner.clientHeight;
            const atTop = inner.scrollTop <= 0;
            const atBottom = inner.scrollTop >= maxScroll - 1;

            const canScrollUp = deltaY < 0 && !atTop;
            const canScrollDown = deltaY > 0 && !atBottom;

            if (canScrollUp || canScrollDown) {
                inner.scrollTop += deltaY;
                return true; // inner scrolled vertically
            } else {
                // inner scroll reached limit and move to main scroll
                main.scrollTop += deltaY;
                return true; // main scrolled vertically
            }
        };

        const handleWheel = (e) => {
            const { deltaY, deltaX } = e;

            // If user is scrolling horizontally, let browser handle it
            if (Math.abs(deltaX) > Math.abs(deltaY)) {
                return; // allow native horizontal scroll
            }

            // Otherwise handle vertical scroll sync
            const consumed = handleScrollAttempt(deltaY, e.target);
            if (consumed) e.preventDefault();
        };

        // Touch support
        const handleTouchStart = (e) => {
            touchStartY = e.touches[0].clientY;
        };

        const handleTouchMove = (e) => {
            const currentY = e.touches[0].clientY;
            const deltaY = touchStartY - currentY;
            const consumed = handleScrollAttempt(deltaY, e.target);
            if (consumed) e.preventDefault();
            touchStartY = currentY;
        };

        main.addEventListener("wheel", handleWheel, { passive: false });
        main.addEventListener("touchstart", handleTouchStart, { passive: true });
        main.addEventListener("touchmove", handleTouchMove, { passive: false });

        return () => {
            main.removeEventListener("wheel", handleWheel);
            main.removeEventListener("touchstart", handleTouchStart);
            main.removeEventListener("touchmove", handleTouchMove);
        };
    }, []);



    if (initialTableData && !initialTableData.length) {
        return (
            <Box sx={{ p: 1 }}>
                <Alert severity="info">
                    <AlertTitle>Info</AlertTitle>
                    Logs for product restrictions are not found!
                </Alert>
            </Box>
        );
    }

    return (
        <TableContainer
            component={Paper}
            className="product-restrictions-container"
            ref={mainScrollRef}
            style={{ maxHeight: "80vh", overflowY: "auto", overflowX: "hidden" }}
        >
            <Table stickyHeader className="table-product-restrictions reports">
                <TableHead className="table-headers">
                    {/* Primary Header */}
                    <TableRow className="primary-header">
                        <TableCell colSpan={2} style={{ ...cellStyleHeader, ...stickyStyle1, left: "0px", zIndex: 5 }}>
                            2025
                        </TableCell>
                        <TableCell style={{ ...cellStyleHeader, ...stickyStyle1, left: "200px", zIndex: 5 }}></TableCell>
                        <TableCell colSpan={5} style={{ ...cellStyleHeader, ...stickyStyle1 }}>
                            Tracking
                        </TableCell>
                    </TableRow>

                    {/* Secondary Header */}
                    <TableRow className="secondary-header">
                        <TableCell rowSpan={2} className="col-date" style={{ ...cellStyleHeader, ...stickyStyle2, left: "0px", zIndex: 5 }}>
                            <Box className="date-cell">
                                <ColumnSorting
                                    label="Date"
                                    colItem={cols[0]}
                                    sorted={cols[0].sorted}
                                    onOrderByChange={onOrderByChangeHandler}
                                />
                                <Box sx={{ ml: 1 }}>Date</Box>
                            </Box>
                        </TableCell>
                        <TableCell rowSpan={2} className="col-dow" style={{ ...cellStyleHeader, ...stickyStyle2, left: "100px", zIndex: 5 }}>
                            <Box className="dow-cell">
                                <ColumnSorting
                                    label="DOW"
                                    colItem={cols[1]}
                                    sorted={cols[1].sorted}
                                    onOrderByChange={onOrderByChangeHandler}
                                />
                                <Box>DOW</Box>
                                <Box className="filter-container">
                                    {visibleDOWTitle.length < 7 && <span className="has-filter"></span>}
                                    <Filter currentColumn={cols[1]} columnList={[]} applyFilterHandler={() => { }} />
                                </Box>
                            </Box>
                        </TableCell>
                        <TableCell className="col-threshold" style={{ ...cellStyleHeader, ...stickyStyle2, left: "200px", zIndex: 5 }}>
                            Threshold({currency_symbol})
                        </TableCell>
                        <TableCell className="col-updated-time" style={{ ...cellStyleHeader, ...stickyStyle2 }}>
                            Updated Time
                        </TableCell>
                        <TableCell className="col-action" style={{ ...cellStyleHeader, ...stickyStyle2 }}>
                            Action
                        </TableCell>
                        <TableCell className="col-status" style={{ ...cellStyleHeader, ...stickyStyle2 }}>
                            Status
                        </TableCell>
                        <TableCell className="col-user" style={{ ...cellStyleHeader, ...stickyStyle2 }}>
                            User
                        </TableCell>
                    </TableRow>
                </TableHead>

                <TableBody className="table-body">
                    <RowStateProvider value={{ prevActiveRow: null, activeRow: null }}>
                        {console.log("Logs data => ", data)}
                        {data.map((dateRow, index) => {
                            const { date, dow, badge_count, threshold_prev, threshold_curr, updated_time, action, status, user, buckets } = dateRow;
                            const rowId = `${date}_${index}`;
                            const dayAndMonth = moment(date).format("MMM DD");
                            const updatedTime = moment.utc(updated_time).local().format("ddd, MMM DD, YYYY, hh:mm A");
                            // const updatedTime = moment(updated_time).format("ddd, MMM DD, YYYY, hh:mm A");
                            const uniqueRoomList = groupRoomTypes(room_settings);

                            return (
                                <React.Fragment key={index}>
                                    <TableRow className={`level-one-row ${index % 2 === 0 ? "even" : "odd"}`}>
                                        <TableCell className="col-date" style={cellStyle}>
                                            <Box className="date-cell">
                                                <NotesPopup params={{ stay_date: date }} />
                                                <Box sx={{ position: "relative" }} onClick={() => onClickHandler(rowId)}>
                                                    <div className="badge-count">{badge_count}</div>
                                                    {dayAndMonth}
                                                </Box>
                                                <IconButton
                                                    className={`toggle-icon ${expandedRows === rowId ? "arrow-up" : "arrow-down"}`}
                                                    size="small"
                                                    onClick={() => onClickHandler(rowId)}
                                                    sx={{ p: 0 }}
                                                >
                                                    {expandedRows === rowId ? icons.arrowUpIcon : icons.arrowDownIcon}
                                                </IconButton>
                                            </Box>
                                        </TableCell>
                                        <TableCell className="col-dow" style={cellStyle}>
                                            <Box className="dow-cell">
                                                <EventsPopup params={{ stay_date: date }} />
                                                <Box>{dow}</Box>
                                            </Box>
                                        </TableCell>
                                        <TableCell className="col-threshold" style={cellStyle}>
                                            <Box className="threshold-cell">
                                                <div>{threshold_prev}</div>
                                                {rightArrowIcon}
                                                <div>{threshold_curr}</div>
                                            </Box>
                                        </TableCell>
                                        <TableCell className="col-updated-time" style={cellStyle}>
                                            {updatedTime}
                                        </TableCell>
                                        <TableCell className="col-action" style={cellStyle}>
                                            {action}
                                        </TableCell>
                                        <TableCell className="col-status" style={cellStyle}>
                                            {status}
                                        </TableCell>
                                        <TableCell className="col-user" style={cellStyle}>
                                            {user}
                                        </TableCell>
                                    </TableRow>

                                    {expandedRows === rowId && (
                                        <TableRow className="expanded-row">
                                            <TableCell colSpan={7} className="col-level-two-container">
                                                <Box
                                                    className="level-two-container level-two-container-scrollable"
                                                    style={{
                                                        overflowX: "auto",
                                                        overflowY: "hidden",
                                                        width: containerWidth,
                                                        position: "relative",
                                                        maxHeight: "400px",
                                                    }}
                                                >
                                                    <StatusDetail
                                                        uniqueRoomList={uniqueRoomList}
                                                        date={date}
                                                        buckets={buckets}
                                                        currency_symbol={currency_symbol}
                                                    />
                                                </Box>
                                            </TableCell>
                                        </TableRow>
                                    )}
                                </React.Fragment>
                            );
                        })}
                    </RowStateProvider>
                </TableBody>
            </Table>
        </TableContainer>
    );
}

export default TableProductRestrictionReports;

function StatusDetail({ uniqueRoomList, date, buckets, currency_symbol }) {
    if (!buckets?.length) {
        return <> <div className='empty-message'>
            No changes were made to any restrictions.
        </div></>
    }

    // if (!buckets?.length) {
    //     return <LevelOneLoader selectedRoomTypes={uniqueRoomList} />;
    // }

    return (
        <Table stickyHeader>
            <TableBody className="table-body">
                <TableRow className="level-two-header" style={{ position: "sticky", top: 0, zIndex: 3 }}>
                    <TableCell className="sell-rate-bucket" style={{ position: "sticky", left: 0, zIndex: 4 }}>
                        Sell Rate Bucket
                    </TableCell>
                    {uniqueRoomList.map((roomType, idx) => (
                        <TableCell key={idx} colSpan={2}>
                            {roomType}
                        </TableCell>
                    ))}
                </TableRow>

                {buckets.map((bucket, index) => (
                    <React.Fragment key={index}>
                        {index === 0 ? (
                            <TableRow className="level-two-header bottom-header">
                                <TableCell className="sell-rate-bucket">{bucket.label}</TableCell>
                                {uniqueRoomList.map((roomType) => (
                                    <React.Fragment key={roomType}>
                                        <TableCell className="col-sell-rate">Sell Rate ({currency_symbol})</TableCell>
                                        <TableCell className="col-restriction">Restrictions</TableCell>
                                    </React.Fragment>
                                ))}
                            </TableRow>
                        ) : (
                            <TableRow className="level-two-header bottom-header">
                                <TableCell className="sell-rate-bucket">{bucket.label}</TableCell>
                                <TableCell colSpan={uniqueRoomList.length * 2}></TableCell>
                            </TableRow>
                        )}

                        {bucket.rate_plans.map((plan) => (
                            <TableRow key={plan.rate_plan_code} className="level-two-row">
                                <TableCell className="sell-rate-bucket">
                                    <Tooltip arrow title={plan?.label} followCursor>
                                        {plan.rate_plan_code}
                                    </Tooltip>{" "}
                                    {renderDefaultRestrictions(plan?.default_restrictions)}
                                </TableCell>
                                {uniqueRoomList.map((roomType) => {
                                    const roomData = plan.rooms_summary.find(
                                        (room) => room.room_type_code === roomType
                                    );
                                    return (
                                        <React.Fragment key={roomType}>
                                            <TableCell className="col-sell-rate">{roomData?.sell_rate ?? "-"}</TableCell>
                                            <TableCell className="col-restrictions">
                                                <Box className="restrictions-container">
                                                    {roomData?.restrictions?.pre
                                                        .filter(r => r?.toLowerCase().replace(/\s+/g, "") !== "mn1")
                                                        .map((r) => (
                                                            <Chip
                                                                key={r + "-pre"}
                                                                className={`restrictions-chips chip-${r.toLowerCase()} removed`}
                                                                label={r}
                                                                variant="outlined"
                                                            />
                                                        ))}
                                                    {roomData?.restrictions?.curr
                                                        .filter(r => r?.toLowerCase().replace(/\s+/g, "") !== "mn1")
                                                        .map((r) => (
                                                            <Chip
                                                                key={r + "-curr"}
                                                                className={`restrictions-chips chip-${r.toLowerCase()}`}
                                                                label={r}
                                                                variant="outlined"
                                                            />
                                                        ))
                                                    }
                                                </Box>
                                            </TableCell>
                                        </React.Fragment>
                                    );
                                })}
                            </TableRow>
                        ))}
                    </React.Fragment>
                ))}
            </TableBody>
        </Table>
    );
}

const LevelOneLoader = ({ selectedRoomTypes }) => {
    const rowCount = Array.from({ length: 3 });

    return (
        <Table style={{ width: "100%" }}>
            <TableRow className="level-two-header">
                <TableCell className="sell-rate-bucket" style={{ width: 350 }}>
                    <Skeleton variant="rounded" height={18} width={314} />
                </TableCell>
                {selectedRoomTypes.map((roomType, index) => (
                    <React.Fragment key={index}>
                        <TableCell colSpan={2}>
                            <Skeleton variant="rounded" height={18} />
                        </TableCell>
                    </React.Fragment>
                ))}
            </TableRow>
            {rowCount.map((_, rowIndex) => (
                <TableRow key={rowIndex} className="level-two-row">
                    <TableCell className="col-rate-bucket" style={{ width: 350 }}>
                        <Skeleton variant="rounded" height={18} width={314} />
                    </TableCell>
                    {selectedRoomTypes.map((roomType, index) => (
                        <React.Fragment key={index}>
                            <TableCell className="col-sell-rate">
                                <Skeleton variant="rounded" height={18} />
                            </TableCell>
                            <TableCell className="col-cur-restrictions">
                                <Skeleton variant="rounded" height={18} />
                            </TableCell>
                        </React.Fragment>
                    ))}
                </TableRow>
            ))}
        </Table>
    );
};